<template>
  <div class="home back">
    <div
      class="background"
    ></div>
    <div
      class="backgroundOverlay"
    ></div>
    <Buchung />
  </div>
</template>

<script>
import Buchung from '@/components/Buchung/Buchung.vue';

export default {
  name: 'Home',
  components: {
    Buchung,
  },
};
</script>

<style scoped>
  .background {
    position:fixed;
    width:100%;height:100%;
    background-image:url('https://www.stretchlimoberlin.de/data/img/Stretchlimousine/Chauffeur.jpg');
    background-size:200%;
    background-position:50% 50%;
  }
  .backgroundOverlay {
    position:fixed;
    width:100%;height:100%;
    background-color:rgba(0,0,0,0.8);
  }

  @media(orientation:portrait) {
    .background {
      background-size:cover;
    }
  }
</style>
